<template>
  <div class="wecoupon-mall-couponcard">
    <CouponItem :amountSize="32" :data="couponInfo" @btnClick="$emit('btnClick')"></CouponItem>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue-demi';
import { CouponInfo } from '../../../../type';
import { CardInfo } from '../../type';
import CouponItem from '../../../coupon-item/index.vue';

export default defineComponent({
  name: 'MallCouponCard',
  components: {
    CouponItem,
  },
  emits: ['btnClick'],
  props: {
    data: {
      type: Object as PropType<CouponInfo & CardInfo>,
      required: true,
    },
  },
  setup(props, context) {
    const couponInfo = computed(() => props.data as CouponInfo);

    return {
      couponInfo,
    };
  },
});
</script>

<style lang="less" scoped>
@import (reference) '../../../../less/main.less';

.wecoupon-mall-couponcard {
  width: 200 / @rem;

  /deep/.wecoupon-coupon-item {
    width: 100%;
    min-height: 308 / @rem;
    border-radius: 8 / @rem;
    box-shadow: none;

    .picture {
      position: relative;
      height: 120 / @rem !important;
      overflow: hidden;
      // padding: 4/@rem;
      box-sizing: border-box;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        box-sizing: border-box;
        border-bottom-right-radius: 13rem 3rem;
        border-bottom-left-radius: 13rem 3rem;
        overflow: hidden;
      }

      &::after {
        display: none;
        content: ' ';
        position: absolute;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        background: none;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .content {
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-items: center;
      margin: 6 / @rem 12 / @rem 16 / @rem 12 / @rem;

      .merchant-info {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        i {
          .font-24-medium(#000000);
        }

        img {
          display: none;
          width: 40 / @rem;
          height: 40 / @rem;
          border: 1 / @rem solid #e2e2e2;
          border-radius: 50%;
        }
      }

      .coupon-name {
        .font-24-regular(#1a1a1a);
        margin-top: 0;
        font-size: 22 / @rem;
        list-style: 30 / @rem;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      .coupon-value-btn {
        flex-direction: column;
        margin-top: 0;

        .coupon-value {
          font-size: 32 / @rem;
          color: #fa5151;
          .amount-medium;
          text-align: center;
          justify-content: center;
          margin-top: 6 / @rem;
          line-height: 32 / @rem;

          i {
            font-size: 32 / @rem;
            color: #fa5151;
            font-family: inherit;
            color: inherit;
            font-style: normal;
          }

          .coupon-amount-box {
            min-height: 34 /@rem;
            display: flex;
            align-items: center;
          }


          .value {
            padding-left: 36 / @rem;
          }

          .value::before {
            top: 4 / @rem;
            left: 0;
            position: absolute;
            z-index: 1;
            content: 'HK$';
            font-size: 16 / @rem;
            line-height: 16 / @rem;
            font-family: inherit;
          }
        }

        .coupon-item-btn {
          position: relative;
          min-width: 56 / @rem !important;
          height: auto;
          padding: 8 / @rem 16 / @rem;
          font-size: 28 / @rem !important;
          line-height: 40 / @rem !important;
          margin-top: 8 / @rem;
          background: #07c160;
          color: #ffffff;
          bottom: 0;
          left: 0;
          top: 0;
          right: 0;
          .font-32-medium(rgb(255, 255, 255));
          border-radius: 8 / @rem;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .coupon-item-btn-1 {
          color: #ffffff;
          background-color: #07c160;
        }

        .coupon-item-btn-2 {
          background: #e6f9ef;
          color: #07c160 !important;
        }

        .coupon-item-btn-3 {
          background: #f2f2f2;
          color: #b3b3b3;
        }

        .coupon-item-btn-6 {
          color: rgba(255, 255, 255, 0);
        }
      }
    }
  }

  // 已抢光的券隐藏按钮、展示邮戳，隐藏底部提示
  /deep/ .wecoupon-coupon-item-3 {

    .content {
      .coupon-value-btn {
        .coupon-item-btn {
          display: none !important;
        }
      }
    }

    .coupon-tips {
      display: none;
    }

    .coupon-item-stamp {
      display: block !important;
    }
  }

  /deep/ .wecoupon-coupon-item-6 {

    .content {
      .coupon-value-btn {
        .coupon-item-btn {
          display: none !important;
        }
      }
    }

    .coupon-tips {
      border-top: 1/@rem dashed #f2f2f2;
      line-height: 26/@rem;
      padding: 8/@rem 10/@rem 0 10/@rem;
      margin-top: 0;
    }
  }

}
</style>
